import * as actionTypes from "./types";
import { ACTION_ERROR } from "../exception-handler/types";

const initialState = {
  loading: false,
  metrics: null,
};

export const dashboardMetricsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_DASHBOARD_METRICS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.GET_DASHBOARD_METRICS_SUCCESS:
      return {
        ...state,
        loading: false,
        metrics: action.payload,
      };

    case ACTION_ERROR:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};
